<template>
    <div class="review-nav bg-white">
        <router-link tag="div" class="review-nav-item div--inlineBlock" v-bind:class="{active: activeIndex === 0}" to="/Rccl.Review/ReviewPicture/Index"><span>秀美图</span></router-link>
        <div class="line div--inlineBlock"></div>
        <router-link tag="div" class="review-nav-item div--inlineBlock" v-bind:class="{active: activeIndex === 1}" to="/Rccl.Review/Travel/TravelNotes"><span>晒游记</span></router-link>
        <div class="line div--inlineBlock"></div>
        <router-link tag="div" class="review-nav-item div--inlineBlock" v-bind:class="{active: activeIndex === 2}" to="/Rccl.Review/Travel/Guide"><span>求攻略</span></router-link>
    </div>
</template>

<script>
    export default {
        name: 'ReviewNav',
        props: {
            activeIndex: {
                type: Number,
                default: 0
            }
        }
    }
</script>

<style lang="less">
    /**** nav ****/
    .review-nav {
        width:100%;
        height: 44px;
        line-height: 44px;
        font-size: 13px;
        color: #777;
        .review-nav-item {
            width: 33.14%;
            text-align: center;
            &.active span{
                color: #061556;
                border-bottom: 2px solid #f9b811;
                padding-bottom: 6px;
            }
        }
        .line {
            width: 1px;
            height: 32px;
            background: #ddd;
        }
    }
</style>
